import BaseAPI from './BaseAPI';
import configuration from '../configuration';

export type ThoughtSpotTokenRequest = {
  AccountToken: string;
  OrgId: string;
  Username: string;
  DisplayName: string;
  // FULL token grants full ThoughtSpot access; OBJECT restricts to specific object IDs
  TokenType: 'FULL' | 'OBJECT';
  // Group to assign the user to on auto-provisioning (must exist in the ThoughtSpot org)
  GroupName?: string;
  AutoCreate?: boolean;
  ValidityTimeInSec?: number;
};

export type ThoughtSpotTokenData = {
  token: string;
  tokenType: 'FULL' | 'OBJECT';
  username: string;
  validityTimeInSec: number;
  expiresAt: string;
  orgId: string;
};

export type ThoughtSpotTokenResponse = {
  status: 'success' | 'error';
  requestId: string;
  data?: ThoughtSpotTokenData;
  metadata?: { thoughtspotHost: string };
  error?: { code: string; message: string };
};

export default class AnalyticsServiceAPI extends BaseAPI {
  // analytics-service lives at api.{env}.tigerconnect.com, not the devapi base URL
  private get tcBaseUrl(): string {
    const { apiEnv } = this.config;
    return configuration.TC_URLS[apiEnv] || `https://api.${apiEnv}.tigerconnect.com`;
  }

  getThoughtSpotToken = async (
    organizationId: string,
    payload: ThoughtSpotTokenRequest
  ): Promise<ThoughtSpotTokenResponse> => {
    const headers = { 'TT-X-Organization-Key': organizationId };
    const url = `${this.tcBaseUrl}/v1/analytics-service/auth/token/thoughtspot`;
    const { data } = await this.httpClient.post(url, {
      headers,
      data: payload,
    });
    return data as unknown as ThoughtSpotTokenResponse;
  };
}
